import { render, staticRenderFns } from "./AppTableRecords.vue?vue&type=template&id=47342f73&scoped=true&"
import script from "./AppTableRecords.vue?vue&type=script&lang=js&"
export * from "./AppTableRecords.vue?vue&type=script&lang=js&"
import style0 from "./AppTableRecords.vue?vue&type=style&index=0&id=47342f73&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47342f73",
  null
  
)

export default component.exports